import PropTypes from 'prop-types';
import FromTo from '~/js/components/form-controls/FromTo';

const { Component } = React;

class DepartmentSelect extends Component {
  static propTypes = {
    resorts: PropTypes.array
  };

  static defaultProps = {
    resorts: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      toggleHiddenOptions: false,
      resorts: this.props.resorts
    };
  }

  handleChange = (event) => {
    const target = event.target;

    if (target.value === '1005') {
      this.setState({toggleHiddenOptions: true});
    } else {
      this.setState({toggleHiddenOptions: false});
    }
  }

  renderResortsOptions = (resorts) => {

    return( resorts.map( rst => <option key={rst.code} value={rst.code}>{rst.shortName}</option> ) );
  }

  render() {
    const { toggleHiddenOptions } = this.state;
    const  resorts  = this.props.resorts;

    return (
      <div className="row">
        <label htmlFor="department" className="form-label xs-12 lg-4">
            Department <span>*</span>
        </label>
        <div className="control-wrapper custom-ddl xs-12 lg-8">
          <select name="department" id="department" required onChange={this.handleChange}>
            <option value="">Select a Department</option>
            <optgroup label="Pre-Travel:">
              <option value="1011">General Information</option>
              <option value="1002">Sandals Select</option>
              <option value="1008">Resort Availability/Rates</option>
              <option value="1009">Promotions/Discounts</option>
              <option value="1006">Wedding Questions</option>
              <option value="1013">Online Reservation</option>
              <option value="1012">Employment</option>
            </optgroup>
            <optgroup label="Post-Travel:">
              <option value="1005">Customer Service</option>
            </optgroup>
          </select>
        </div>
        { toggleHiddenOptions &&
        <div className="customer-service-options xs-12">
          <div className="row">
            <p className="xs-12 customer-details">On behalf of Sandals Resorts, thank you for contacting Sandals Resorts International, Customer Service Department. In order to respond to your post-travel inquiries in an expedient manner, please complete the required fields below.</p>
            <label htmlFor="bookingLeadName" className="form-label xs-12 lg-4">
              Booking Lead Name
              <b className="label-subtext tablet-break single-line"> (FIRST AND LAST)<span>*</span></b>
            </label>
            <div className="control-wrapper mrgn-bottom-6 xs-12 lg-8">
              <input type="text" id="bookingLeadName" name="bookingLeadName" required />
            </div>

            <label htmlFor="resort" className="form-label xs-12 lg-4">
                Resort <span>*</span>
            </label>
            <div className="control-wrapper custom-ddl xs-12 lg-8">
              <select name="resort" id="resort" required>
                <option value="">Where did you stay?</option>
                { this.renderResortsOptions(resorts) }
              </select>
            </div>

            <label htmlFor="travelDates" className="form-label xs-12 lg-4">
                Travel Dates <span>*</span>
            </label>

            <FromTo
              dateFromName="fromDate"
              dateToName="toDate"
              isRequired
              toPast
              toFuture
              wrapperClassNameFrom="xs-5 lg-5"
              wrapperClassNameTo="xs-5 lg-5"
              fromPlaceHolder="From Dates"
              toPlaceHolder="To Dates"
            />

            <label htmlFor="bookingNumber" className="form-label xs-12 lg-4">
                Booking # <span>*</span>
            </label>
            <div className="control-wrapper mrgn-bottom-6 xs-12 lg-8">
              <input type="text" id="bookingNumber" name="bookingNumber" required/>
            </div>
          </div>
        </div>
        }
      </div>
    );
  }
}

export default DepartmentSelect;
